import React from 'react';
import MathJax from 'react-mathjax';
import reactStringReplace from 'react-string-replace';
import { hasMathJaxPattern } from '../../utils/Util';

/**
 * To render text with mathjax
 * Example: test $$co^2$$
 * @param {string} text with mathjax formula
 */
function Mathjax({ value }) {
    if (hasMathJaxPattern(value)) {
        const mathJaxConfig = {};
        return (
            <MathJax.Provider script={null} options={mathJaxConfig}>
                {reactStringReplace(value, /\$\$?(.+?)\$\$?/g, (match, i) => {
                    return <MathJax.Node key={i} inline formula={match} />;
                })}
            </MathJax.Provider>
        );
    } else {
        return value;
    }
}

export default Mathjax;
